import auth from "../config/firebase.jsx";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import "./Login.css";

const Login = () => {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [user, loading, error] = useAuthState(auth);
    const navigate = useNavigate();

    const signIn = async (e) => {
        try {
            e.preventDefault();
            await signInWithEmailAndPassword(auth, email, password);
        } catch (err) {
            console.error(err);
            alert(err.message);
        }
    };

    useEffect(() => {
        if (user) navigate("/mart");
    }, [user, loading]);
    

    return (
    <div className="login">
        <div className="login__container">
            <form onSubmit={signIn}>
                <img 
                className="logo" 
                src="https://mwh.muhammadiyah.org.sg/wp-content/uploads/2021/06/MWHLOGO-2021-01.png" 
                alt="Muhammadiyah Welfare Home" />
                <div>
                    <h2>Welcome to the Minimart!</h2>
                    <h2>Login</h2>
                    <input type="email" name="email" placeholder="Email" onChange={(e)=> setEmail(e.target.value)} required=""></input>
                    <input type="password" name="pswd" placeholder="Password" onChange={(e)=> setPassword(e.target.value)} required=""></input>
                    <button onClick={signIn}>Login</button>
                </div>
            </form>
        </div>
    </div>
    );
};

export default Login;

// https://blog.logrocket.com/user-authentication-firebase-react-apps/